<template>
  <!-- 网站评分 -->
  <div class="WebsiteRatingModel" :class="{ 'ON': isShow == true }">
    <div class="iconfont icon-cha" @click="close"></div>
    <div class="title">你愿意向好友推荐【潮国创意】网站吗?</div>
    <div class="rating-box">
      <div class="rating">
        <div
          class="rating-item"
          :class="{ 'ON': rating == index }"
          v-for="(vo,index) in 11"
          :key="index"
          @click="toggleRating(index)"
        >
          {{ index }}
        </div>
      </div>
      <div class="emoji">
        <div class="bad">
          <i class="icon_bad"></i>绝不！
        </div>
        <div class="smile">
          <i class="icon_small"></i>强推！
        </div>
      </div>
    </div>
    <div class="reason-box" v-if="rating < 8 && rating > -1">
      <div class="title">请问你不推荐的理由是? <i>(可多选)</i></div>
      <div class="reason-list">
        <div class="reason-item"
             :class="{ 'ON': vo.checked }"
             v-for="(vo,vIndex) in WEBSITE_RATING.REASON_LIST"
             :key="vIndex"
             @click="toggleReason(vo,vIndex)"
        >
          {{ vo.label }}
        </div>
        <div class="reason-item"
             :class="{ 'ON': isCheckedOther }"
             @click="toggleReasonOther()"
        >
          {{ '其他' }}
        </div>
      </div>
      <input type="text" v-if="isCheckedOther" v-model="customReason"
             class="custom-reason" placeholder="理由"
             @input="inputCustomReason"
             @blur="inputCustomReason"
      >
      <div class="err-txt" v-if="isShowOtherText">请选择或输入理由</div>
      <div class="form-submit">
        <div class="button cancel _hide" @click="cancel">取 消</div>
        <div class="button submit" @click="submit">提 交</div>
      </div>
    </div>

    <div class="share-box" v-if="rating > 7">
      <div class="share-txt overflow-one">{{ shareTxt }}</div>
      <div class="share-btn text-copy" @click="copy">一键分享</div>
    </div>
  </div>
</template>

<script>
import {WEBSITE_RATING} from '@/constant/common/stat/WEBSITE_RATING'
import _ from 'lodash'
import {getWebsiteRatingStatus, submitWebsiteRating} from "@/api/common/stat/website-rating";
import {fnClipboard, fnLocalStorage, fnLogin} from "@/fn";
import {MODEL_WEBSITE_RATING} from "@/constant/MODELS";
import {mapState} from "vuex";

export default {
  name: "WebsiteRatingModel",
  data() {
    return {
      WEBSITE_RATING,
      customReason: '',
      rating: -1,
      shareTxt: '推荐一个宝藏网站：潮国创意，高品质3D/电商/海报一网打尽，现在注册就能免费下载！',
      isCheckedOther: false,
      isShow: false,
      isShowOtherText: false
    }
  },
  computed: {
    reasonList() {
      return this.WEBSITE_RATING.REASON_LIST
    },
    ...mapState('user', ['uniq_id'])
  },
  watch: {
    isCheckedOther: {
      handler(n, o) {
        if (n == true) {
          this.initRatingReasonList();
        } else {
          this.customReason = '';
        }
      }
    },

    isLogin(n, o) {
      if (n == true ) {
        console.log(1111)
        this.init();
      }
    },
  },
  mounted() {

    this.init();
  },
  methods: {
    init() {
      this.initRatingReasonList();
      this.initShareUrl();
      this.checkShow();
    },

    checkShow() {
      /* 未填写 当天已关闭的 */
      if (!fnLocalStorage.getItemDate(MODEL_WEBSITE_RATING)){
        getWebsiteRatingStatus().then(res => {
          if (res.data.data.allow == 1) {
            window.setTimeout(() => {
              this.isShow = !fnLocalStorage.getItemDate(MODEL_WEBSITE_RATING);
            }, 5000)
          }
        })
      }
    },

    initRatingReasonList() {
      this.WEBSITE_RATING.REASON_LIST.forEach(vo => {
        vo.checked = false;
      })
    },

    initShareUrl() {
      if (fnLogin.checkLogin()) {
        this.shareTxt += `https://chaopx.com?invite=${this.uniq_id}`
      }
    },

    toggleRating: _.throttle(function (index) {
      this.rating = index;
    }, 0),

    cancel() {

    },


    checkForm() {
      console.log(this.WEBSITE_RATING.REASON_LIST.some(vo => vo.checked == true))
      console.log(this.customReason != '')
      return this.WEBSITE_RATING.REASON_LIST.some(vo => vo.checked == true) || this.customReason != ''
    },
    submit() {

      if (this.checkForm()) {
        this.isShowOtherText = false
        console.log('验证通过')
        submitWebsiteRating({
          lapNumber: 1,
          score: this.rating,
          remark: this.getReason()
        }).then(res => {

          let {status, message} = res.data;
          if (status == 200) {
            this.$myNotify.success('提交成功', () => {
              this.close();
              this.isShow = false;
            })
          } else {
            this.$myNotify.show(message, () => {
              this.close();
              this.isShow = false;
            })
          }

        })

      } else {
        this.isShowOtherText = true
      }

    },

    /* 获取理由 */
    getReason() {
      let remark = []
      if (this.isCheckedOther) {
        remark.push(this.customReason)
      } else {
        this.WEBSITE_RATING.REASON_LIST.forEach(item => {
          if (item.checked) {
            remark.push(item.label)
          }
        })
      }
      return remark.join(',')
    },


    toggleReason(vo, index) {
      this.isCheckedOther = false;
      vo.checked = !vo.checked;
      this.isShowOtherText = !this.WEBSITE_RATING.REASON_LIST.some(vo => vo.checked == true)
      this.$set(this.WEBSITE_RATING.REASON_LIST, index, vo)
    },
    toggleReasonOther() {
      this.isCheckedOther = !this.isCheckedOther;
    },
    close() {
      this.isShow = false;
      fnLocalStorage.setItemDate(MODEL_WEBSITE_RATING, 1)
      this.checkIsClickMoreSeven();
    },

    inputCustomReason() {
      let reg = /\s+/g;
      this.customReason = this.customReason.replace(reg, '');
      this.isShowOtherText = this.customReason.length == 0
    },

    copy() {
      fnClipboard.copy(this.shareTxt)
      this.checkIsClickMoreSeven();
    },

    /* 检查是否点击大于7分的 */
    checkIsClickMoreSeven(){

      if (this.rating >7){
        submitWebsiteRating({
          lapNumber: 1,
          score: this.rating,
          remark: ''
        }).then(res => {

          /*let {status, message} = res.data;
          if (status == 200) {
            this.$myNotify.success('提交成功', () => {
              this.close();
              this.isShow = false;
            })
          } else {
            this.$myNotify.show(message, () => {
              this.close();
              this.isShow = false;
            })
          }*/

        })
      }

    }
  }
}
</script>

<style lang="scss" scoped>
.WebsiteRatingModel {
  position: fixed;
  right: -99954px;
  z-index: 50;
  bottom: 100px;
  width: 476px;
  //height: 146px;
  background: #FFFFFF;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 24px 20px;
  box-sizing: border-box;
  transition: all 2s ease;

  &.ON{
    right: 54px !important;
  }

  .icon-cha {
    @include Position(1, 2, 10px, 10px);
    @include ElementHover($color-primary,'');
    padding: 10px;
  }

  > .title {
    font-size: 14px;
    font-weight: bold;
    color: #131519;
    line-height: 20px;
    margin-bottom: 16px;
  }

  .rating-box {

    .rating {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;

      .rating-item {
        width: 32px;
        height: 32px;
        border-radius: 6px;
        border: 1px solid rgba(89, 96, 136, 0.15);
        text-align: center;
        line-height: 32px;
        //margin-right: 8px;
        font-size: 12px;
        color: rgba(25, 39, 42, 1);
        cursor: pointer;
        @include ElementHover($color-primary, '') {
          border-color: $color-primary;
        }

        &.ON {
          border: 1px solid $color-primary;
          color: $color-primary;
        }
      }
    }

    .emoji {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      color: rgba(89, 96, 136, 0.5);
      line-height: 20px;

      .bad, .small {
        display: flex;
        align-items: center;
        justify-content: center;

      }

      .icon_bad {
        @include BgImage(16px, 16px, 'common/stat/website-rating-model/icon_bad2.png');
        margin-right: 4px;
        position: relative;
        top: -1px;
      }

      .icon_small {
        @include BgImage(16px, 16px, 'common/stat/website-rating-model/icon_small2.png');
        margin-right: 4px;
        position: relative;
        top: -1px;
      }
    }

  }

  .reason-box {
    margin-top: 30px;

    .title {
      font-size: 14px;
      font-weight: bold;
      color: #001013;
      line-height: 20px;
      margin-bottom: 16px;

      > i {
        font-size: 14px;
        line-height: 20px;
        color: rgba(89, 96, 136, 0.5);
        font-weight: normal;
        margin-left: 4px;
      }
    }

    .reason-list {
      display: flex;
      flex-wrap: wrap;

      .reason-item {
        width: 140px;
        height: 32px;
        border-radius: 6px;
        border: 1px solid rgba(89, 96, 136, 0.25);
        margin: 0 8px 8px 0;
        box-sizing: border-box;
        line-height: 30px;
        text-align: center;
        font-size: 12px;
        color: #19272A;
        cursor: pointer;

        &.ON {
          border-color: rgba(105, 105, 255, 1);
          color: rgba(105, 105, 255, 1);
        }


        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }

    .err-txt {
      font-size: 12px;
      color: #EE5253;
      line-height: 16px;
      padding-left: 15px;
      padding-top: 2px;
    }

    .custom-reason {
      width: 100%;
      height: 32px;
      border-radius: 6px;
      border: 1px solid rgba(89, 96, 136, 0.25);
      box-sizing: border-box;
      padding: 0 16px;
      font-size: 12px;
      color: #19272A;
    }

    .form-submit {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 30px;

      .button {
        width: 90px;
        height: 36px;
        background: #EBEDF5;
        border-radius: 6px;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        cursor: pointer;
      }

      .cancel {
        background: #EBEDF5;
      }

      .submit {
        background: #6969FF;
        margin-left: 16px;
        color: #FFFFFF;
        @include ElementHover('', #5E5EE8)
      }
    }
  }

  .share-box {
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    margin-top: 20px;

    .share-txt {
      width: 345px;
      height: 36px;
      line-height: 36px;
      background: #F5F6FA;
      padding: 0 14px;
      box-sizing: border-box;
    }

    .share-btn {
      @include Position(1, 2, 0, 0);
      width: 91px;
      height: 36px;
      background: #6969FF;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 36px;
      text-align: center;
      cursor: pointer;

      @include ElementHover('', #5E5EE8)
    }
  }


}
</style>
